<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="
                $l('pending_plan_label_search') ||
                  '包装计划编号/订单编码搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
      <el-dialog
        :title="$l('INDEX.advanced_search') || '高级搜索'"
        :show-close="true"
        :visible.sync="advqueryDialogVisible"
        width="750px"
        :close-on-click-modal="false"
      >
        <el-form ref="form" :model="form" size="small">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_mrpPackagePlanNo') || '包装计划编号'"
              >
                <el-input
                  v-model.trim="form.mrpPackagePlanNo"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.order_form_label_orderNo') || '订单编码'"
              >
                <el-input v-model.trim="form.orderNo" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('INDEX.table_label_modification_date') || '修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_reviewTime') || '审核时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginReviewTime"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endReviewTime"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="10">
            <el-col :span="12">
              <el-col :span="12">
                <el-form-item
                  :label="$l('INDEX.table_label_created_date') || '创建时间'"
                >
                  <el-date-picker
                    v-model="form.beginCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="beginCreateStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="-">
                  <el-date-picker
                    v-model="form.endCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="endCreateStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="12">
                <el-form-item
                  :label="
                    $l('INDEX.table_label_modification_time') || '修改时间'
                  "
                >
                  <el-date-picker
                    v-model="form.beginModifyDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="-">
                  <el-date-picker
                    v-model="form.endModifyDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-col>

            <el-col :span="12">
              <el-col :span="12">
                <el-form-item
                  :label="
                    $l('INDEX.table_label_reviewer_by_time') || '审核时间'
                  "
                >
                  <el-date-picker
                    v-model="form.beginReviewTime"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="reviewTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="-">
                  <el-date-picker
                    v-model="form.endReviewTime"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="reviewTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_planStatus') || '订单状态'"
                >
                  <dict-select
                    multiple
                    clearable
                    filterable
                    v-model="form.planStatusList"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    size="small"
                    url="/sys/common/dict/system"
                    :body="{ dictType: 'planStatus' }"
                  ></dict-select>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeAdvqueryDialog">{{
            $l("INDEX.btn_cancel_query") || "取消查询"
          }}</el-button>
          <el-button size="small" type="warning" @click="reload">{{
            $l("INDEX.btn_reset_filter") || "重置条件"
          }}</el-button>
          <el-button size="small" type="primary" @click="advquery">{{
            $l("INDEX.btn_data_retrieval") || "数据检索"
          }}</el-button>
        </span>
      </el-dialog>
    </b-row>
  </div>
</template>

<script>
const initForm = {
  keyword: "",
  planStatusList: ["N", "D", "Y", "P", "T", "C"],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      //创建时间
      beginCreateStartPicker: this.dateCreateEnd(),
      endCreateStartPicker: this.dateCreateStart(),
      //修改时间
      modifyTimeStartPicker: this.dateModityEnd(),
      modifyTimeEndPicker: this.dateModityStart(),
      //审核时间
      reviewTimeStartPicker: this.dateReviewTimeEnd(),
      reviewTimeEndPicker: this.dateReviewTimeStart(),
    }
  },
  created() {
    this.query()
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit("reload")
      }
      this.$emit("query", this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ""
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    dateReviewTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endReviewTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endReviewTime).getTime() < time.getTime()
          }
        },
      }
    },
    dateReviewTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginReviewTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginReviewTime).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    dateModityEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endModifyDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endModifyDate).getTime() < time.getTime()
          }
        },
      }
    },
    dateModityStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginModifyDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginModifyDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    dateCreateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endCreateDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endCreateDate).getTime() < time.getTime()
          }
        },
      }
    },
    dateCreateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginCreateDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginCreateDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
